<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        block
        v-on="on"
      >
        Create Section
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Section"
      text="Create Section"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                outlined            
                label="Name"
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="departmentId"
                v-validate="'required'"
                :error-messages="errors.collect('departmentId')"
                :items="departments"
                data-vv-name="departmentId"
                data-vv-as="department"   
                item-text="name"
                item-value="id"
                value="id"
                outlined            
                label="Department"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text px-10"     
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        name: null,
        departmentId: null,
        departments: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
      },
    },
    methods: { 
      prepareFormData () {
        return {
          name: this.name,
          department_id: this.departmentId,
        }
      },
      loadDepartments () {
        this.$api.hrisDepartments().list(['name'], false)
          .then((res) => {
            this.departments = res.data
          })
          .catch(() => {})
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.hrisSections().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new section' })

                  this.setDialog(false)                
                }
              })
              .catch((err) => {
                if (err.response.status === 500) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.setProgressing(false)
              })
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      resetForm () {
        this.$validator.reset()
        this.loadDepartments()
        this.name = null
        this.department_id = null
      },
    },
  }
</script>
